import intlTelInput from 'intl-tel-input';

export const phoneNumberInput = document.querySelector('input[type="tel"]');

const phoneNumber = () => {
  if (!phoneNumberInput) {
    return {
      init: () => {
        console.warn('Missed phone number input')
      },
    }
  }

  const iti = intlTelInput(phoneNumberInput, {
    geoIpLookup: (callback) => {
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          callback(data.country_code);
        })
        .catch(() => {
          callback('gb');
        });
    },
    formatOnDisplay: true,
    separateDialCode: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
    nationalMode: true,
    initialCountry: 'auto',
  });


  const setupListeners = () => {
    if (!phoneNumberInput) return;

    phoneNumberInput.addEventListener('keyup', (e) => {
      e.preventDefault();
      let phoneNumber = e.target.value;

      // phoneNumber = phoneNumber.replaceAll('+', '');
      phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

      phoneNumberInput.value = phoneNumber;
    });
  }

  const isValidPhoneNumber = () => {
    if (!phoneNumberInput) return;
    return iti.isValidNumber();
  }

  const getValidationErrorText = () => {
    if (!phoneNumberInput) return;

    const phoneInputValidationErr = window.intlTelInputGlobals.getInstance(phoneNumberInput).getValidationError();

    let phoneNumberErrorText = 'Invalid phone number - please try again';

    if (phoneInputValidationErr === 2) {
      phoneNumberErrorText = 'Phone number to short!';
    } else if (phoneInputValidationErr === 1) {
      phoneNumberErrorText = 'Invalid country code!';
    } else if (phoneInputValidationErr === 3) {
      phoneNumberErrorText = 'Phone number to long!';
    }

    return phoneNumberErrorText;
  }

  const getPhoneWithCountryCode = () => {
    return iti.getNumber();
  }

  return {
    init: setupListeners,
    isValidPhoneNumber,
    getValidationErrorText,
    getPhoneWithCountryCode,
  }
}

export default phoneNumber;
